module.exports = "<itpx-learning-tile [deliverableStatus]=\"deliverableStatus\" [status]=\"status\" [target]=\"target\" [logo]=\"'elearning.png'\"\n                    [name]=\"name\" [errorMessage]=\"errorMessage\" [disabled]=\"deliverable.disabled\"\n                    [availableUntil]=\"deliverable.availableUntil\" [deliverable]=\"deliverable\" [isElearning]=\"true\">\n</itpx-learning-tile>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/content/scormcloud/tile.component.html
// module id = 866
// module chunks = 0